import axios from "axios";
import { TokenService } from "./storage.service";
import store from "../store/store";
import { ACTION_LOGOUT } from "../store/constants/user";

class Axios {
  constructor() {
    const instance = axios.create();

    instance.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        const status = error.response ? error.response.status : null;
        if (status === 401) {
          store.dispatch(ACTION_LOGOUT);
        }
        throw error;
      }
    );
    instance.setHeaders = this.setHeaders;
    instance.removeHeaders = this.removeHeaders;
    instance.set2FAHeader = this.set2FAHeader;
    instance.remove2FAHeader = this.remove2FAHeader;

    return instance;
  }

  setHeaders(token = null) {
    if (token) {
      this.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      this.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${TokenService.getConfig("token")}`;
    }
  }
  set2FAHeader(token) {
    this.defaults.headers.common["X-Two-Fa-Code"] = `${token}`;
  }
  remove2FAHeader() {
    delete this.defaults.headers.common["X-Two-Fa-Code"];
  }
  removeHeaders() {
    this.defaults.headers.common = {};
  }
}

export default new Axios();
